// confirm-modal.component.ts
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirm-modal',
    template: `
        <div
            class="fixed inset-0 bg-black/50 backdrop-blur-xs flex justify-center items-center z-[9999] p-4"
        >
            <div class="relative bg-white p-6 rounded-2xl shadow-2xl w-full max-w-[340px] text-center transform transition-all">
                <button
                    class="absolute top-4 right-4 text-slate-400 hover:text-slate-600 cursor-pointer p-1 rounded-lg hover:bg-slate-100 transition-colors"
                    (click)="cancel()"
                    aria-label="Close"
                >
                    <img
                        src="assets/icons/icon-close.svg"
                        alt="close"
                        class="w-4 h-4"
                    />
                </button>
                <div class="flex flex-col justify-center items-center mt-1">
                    <img
                        src="assets/icons/warning-icon.svg"
                        class="w-16 h-16 mb-3 drop-shadow-sm"
                        alt="Warning"
                    />
                    <p class="mb-6 text-[#0d2847] text-sm font-medium leading-relaxed">
                        {{ message }}
                    </p>
                </div>
                <div class="flex justify-center items-center gap-3">
                    <button
                        class="px-4 py-2 rounded-xl bg-white hover:bg-slate-50 border border-slate-300 cursor-pointer text-slate-700 font-medium text-sm transition-all"
                        (click)="cancel()"
                    >
                        Batal
                    </button>
                    <button
                        class="px-5 py-2 rounded-xl bg-[#1B5091] hover:bg-[#15427b] text-white font-semibold text-sm transition-all shadow-md cursor-pointer"
                        (click)="confirm()"
                    >
                        Konfirmasi
                    </button>
                </div>
            </div>
        </div>
    `,
})
export class ConfirmModalComponent {
    @Input() message: string = 'Apakah Anda yakin?';
    private result$ = new Subject<boolean>();

    confirm() {
        this.result$.next(true);
        this.result$.complete();
    }

    cancel() {
        this.result$.next(false);
        this.result$.complete();
    }

    getResult() {
        return this.result$.asObservable();
    }
}
